import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import {
    useOrders, getPaymentUrl, paymentWithToken, deleteToken
} from "../../context/orders/OrdersState";

import popupStyles from "../../css/custom-popup.module.css"
import PaymentMessage from './PaymentMessage';

const Payment = ({amount, orderId, showPayment, onClose, paymentFinished}) => {
  
  const [ordersState, ordersDispatch] = useOrders();
  const navigate = useNavigate();

  const {
    url, currentOrder, credit_process, tokens, credit_token_status, loading
  } = ordersState;

  const [show, setShow] = useState(true);
  const [iframeError, setIframeError] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);
  const [useNewCredit, setUseNewCredit] = useState(false);
  const [askDeleteToken, setAskDeleteToken] = useState(false);

  const closeHandler = (e) => {
    console.log(e.target.className + "!!!");
    if(e.target.className === popupStyles.overlay || e.target.className === popupStyles.close){
      setShow(false);
      onClose();
    }
  };

  useEffect(() => {
    const fetchPaymentForm = async () => {
      if (/*true || !url &&*/ (tokens?.length === 0 || useNewCredit)) {
        try {
          console.log("getting url");
          getPaymentUrl(ordersDispatch, amount, orderId);
        } catch (error) {
          console.error('Error fetching payment form:', error);
        }
      }
    };
    localStorage.setItem('paymentComplete', 'false');
    fetchPaymentForm();
  }, [useNewCredit, tokens]);

  useEffect(() => {
    const iframe = document.getElementById('payment_iframe');
    console.log(iframe);

   if (iframe) {
    console.log("in if iframe");
    iframe.onload = () => {
      // You cannot directly check the response status due to cross-origin restrictions.
      // But you can check if the iframe content is accessible (only for same-origin).
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc && (iframeDoc.body.innerHTML.includes('404') || iframeDoc.body.innerHTML.includes('410'))) {
          setIframeError(true);
        } else {
          setIframeError(false);
        }
      } catch (error) {
        console.log(error);
        console.log("in catch");
        // If iframe content cannot be accessed, assume there might be an error.
        //setIframeError(true);
      }
   
    };

    console.log("ifrmaeError: " + iframeError);

    iframe.onerror = () => {
      console.log("setting iframe error");
      setIframeError(true);
    };
  }  else {
    console.log("in else, no iframe");
  }
  }, []);

console.log(url);
console.log("show " + show);
console.log("credit_process: " + credit_process);
console.log("url::::::::: " + url);
console.log("iframe error: " + iframeError);

console.log(tokens);
return (
  askDeleteToken ? (
      <Dialog
          title="מחיקת כרטיס"
          onClose={(e) => {setAskDeleteToken(false);}}
          className="pop-up"
        >
          <p>האם אתה בטוח שברצונך למחוק את הכרטיס המסתיים ב {selectedToken.token} ?</p>
        <DialogActionsBar>
        <button
            className="submit btn"
            onClick={(e)=>{ 
              deleteToken(ordersDispatch, orderId, selectedToken);
              setAskDeleteToken(false);
              setSelectedToken(null);
            }
            }
          >
            אישור
          </button>
          <button className="cancel btn" onClick={(e)=>{setAskDeleteToken(false);}}>
            ביטול
          </button>
        </DialogActionsBar>
      </Dialog>
  ) : (
    credit_process && (
    <div
      style={{
        visibility: showPayment ? "visible" : "hidden",
        opacity: showPayment ? "1" : "0",
      }}
      className={popupStyles.overlay}
      onClick={closeHandler}
    >
      <div className={`${popupStyles.popup} credit_popup ${(paymentFinished || (!useNewCredit && tokens?.length)) ? "small" : ""}`}>
        <span className={popupStyles.close} onClick={closeHandler}>
          &times;
        </span>
        {(loading) && (
            <div className="overley_page small">
              <Loader type="converging-spinner" />
            </div>
          )}
        {((useNewCredit || !tokens?.length))? (
          iframeError ? (
            <div className="payment_thanks">
              <h1>שימ/י לב:</h1>
              <p>פג תוקף הלינק לתשלום</p>
              <p>אנא נסה/י שנית</p>
            </div>
          ) : (
            <iframe
              id="payment_iframe"
              src={url}
              width="100%"
              height="100%"
              allowFullScreen
              title="Payment Gateway"
              allow="payment"
            />
          )
        ) : ((!credit_token_status && tokens?.length) ? <>
          <p class="title-text">בחר כרטיס אשראי מהמערכת</p>
          <DropDownList
            className="tokens_select"
            data={tokens}
            textField="token" 
            dataItemKey="id"  
            value={selectedToken ?? { token: "כרטיס אשראי המסתיים ב ", id: null }}
            onChange={(e) => setSelectedToken(e.value)}
            defaultItem={{ token: "כרטיס אשראי המסתיים ב ", id: null }}
          />
          <div><button class="use_credit saved_credit btn" onClick={() => selectedToken ? paymentWithToken(ordersDispatch, orderId, selectedToken) : ''}>השתמש בכרטיס הנבחר</button></div>
          <div><button class="use_credit delete_credit btn" onClick={() => selectedToken ? setAskDeleteToken(true) : ''}>מחק את הכרטיס הנבחר</button></div>
          <div><button class="use_credit new_credit btn" onClick={() => setUseNewCredit(true)}>כרטיס אשראי חדש</button></div>
          
          </> : (credit_token_status ? <PaymentMessage status={credit_token_status}/> : <></>))
        }
      </div>
    </div>
  )
));

};

export default Payment;